import { useEffect } from "react";
import { useAuth } from "../../provider/AuthContext";

// Starts tracking once a tenant user is signed in (login or reload), follows
// business-unit switches within the same session, and stops on sign-out.
const AnalyticsSessionSync = () => {
  const { user, tenantId, selectedBusinessUnit, isAuthenticated, isLoading } = useAuth();
  const userId = user?.user_id;
  const buId = selectedBusinessUnit?.business_unit_id;

  useEffect(() => {
    if (isLoading) return;
    if (isAuthenticated && userId && tenantId && buId) {
      window.__ANALYTICS__?.start?.({ userId, tenantId, buId });
    } else if (!isAuthenticated) {
      window.__ANALYTICS__?.stop?.("logout");
    }
  }, [isLoading, isAuthenticated, userId, tenantId, buId]);

  return null;
};

export default AnalyticsSessionSync;
